// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Nua","newExpiryDate":"styles_newExpiryDate__1_2lz","footer":"styles_footer__3PEzw"};